export type ConfluencePage = {
  hostname: string;
  spaceKey: string;
  contentId: string;
};

// Short/share links don't contain a space key and page ID. Keep those as source links.
export const parseConfluencePageUrl = (url: string): ConfluencePage | null => {
  try {
    const parsed = new URL(url);
    if (
      parsed.protocol !== 'https:' ||
      parsed.username ||
      parsed.password ||
      parsed.port ||
      !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.atlassian\.net$/.test(parsed.hostname)
    ) {
      return null;
    }

    const match = parsed.pathname.match(
      /^\/wiki\/spaces\/([^/]+)\/pages\/([1-9]\d*)(?:\/[^/]+)?\/?$/
    );
    if (!match) return null;

    const spaceKey = decodeURIComponent(match[1]);
    if (!/^[\w~:-]+$/.test(spaceKey)) return null;

    return {hostname: parsed.hostname, spaceKey, contentId: match[2]};
  } catch {
    return null;
  }
};

export const getConfluenceEmbedConfig = (url: string) => {
  // This public SDK identifier opts the preview in. Atlassian must confirm its
  // value and allowlist the host application's domain before live testing.
  const parentProduct = import.meta.env.VITE_CONFLUENCE_PARENT_PRODUCT?.trim();
  const page = parentProduct ? parseConfluencePageUrl(url.trim()) : null;
  return parentProduct && page ? {page, parentProduct} : null;
};
